import { isNil, isBoolean } from 'lodash';
import { omitBy } from 'lodash';
import {
  CASE_STATUS_ARCHIVED,
  CASE_STATUS_COMPLETED,
  CASE_STATUS_CREATED,
  CASE_STATUS_DRAFTED,
  CASE_STATUS_SUBMITTED,
} from '../pages/Case/CaseConstants';
import { STUDY_PURPOSES } from '../appContants';
import { Col, Row, Tag } from 'antd';
import { APP_TERMS } from '../app-terms';
import { formatDate } from './date';

export const mapPatientDetailsToCase = (data) => {
  if (!data) return;
  return {
    doctorUserSub: data?.doctorUserSub,
    scannedAt: data?.scannedAt,
    clinicPatientId: data?.clinicPatientId,
    patient: {
      platformId: data?.platformId,
      firstName: data?.firstName,
      lastName: data?.lastName,
      gender: data?.gender,
      dob: data?.dob,
    },
  };
};
export const mapCaseToPatientDetails = (caseData) => {
  if (!caseData) return;
  return {
    doctorUserSub: caseData?.doctorUserSub,
    scannedAt: caseData?.scannedAt,
    clinicPatientId: caseData?.clinicPatientId,
    ...(caseData?.patient || {}),
  };
};
export const mapStudyPurposeToCase = (data) => {
  if (!data) return;
  return omitBy(data, isNil);
};
export const mapCaseToStudyPurpose = (caseData) => {
  if (!caseData) return;
  return {
    ...(caseData?.studyPurpose || {}),
  };
};
export const mapServiceToCaseService = (service) => ({
  serviceId: service?.serviceId,
  hasRush: service?.hasRush || false,
});
export const mapServicesToCase = (data) => {
  if (!data) return;
  return {
    services: data?.map(mapServiceToCaseService) || [],
  };
};
export const mapCaseToServices = (caseData) => {
  if (!caseData) return;
  return {
    services:
      caseData?.services?.map((d) => ({
        ...d,
        isSelected: true,
      })) || [],
  };
};
export const mapAntFileToServerFile = (file) => {
  if (!file) return;
  return {
    fileName: file?.name,
    fileSize: file?.size,
    objectKey: file?.response?.file?.uid || file?.uid,
  };
};
export const mapServerFileToAntFile = (file) => {
  if (!file) return;
  return {
    name: file?.fileName,
    size: file?.fileSize,
    uid: file?.objectKey,
  };
};
export const mapCaseToUpload = (caseData) => {
  if (!caseData) return;
  return {
    files: caseData?.files?.map(mapServerFileToAntFile) || [],
  };
};
export const getPatientDetailInfoItems = (caseDetails, userLocale) => {
  return [
    {
      label: 'Patient Details',
      value: `${caseDetails?.patient?.firstName || ''} ${
        caseDetails?.patient?.lastName || ''
      }`,
    },
    {
      label: 'Gender',
      value: caseDetails?.patient?.gender,
    },
    {
      label: 'Date Of Birth',
      value:
        caseDetails?.patient?.dob &&
        formatDate(
          caseDetails?.patient?.dob,
          APP_TERMS.date_1_format,
          userLocale
        ),
    },
    {
      label: 'Scan Date',
      value:
        caseDetails?.scannedAt &&
        formatDate(caseDetails?.scannedAt, APP_TERMS.date_1_format, userLocale),
    },
    // TODO: need to clarify for data source for below info
    // {
    //   label: 'Submitting Office',
    //   value: caseDetails?.scannedAt,
    // },
    {
      label: 'Referring Doctor',
      value: caseDetails?.doctorName,
    },
  ];
};
export const getStudyPurposeInfoItems = (caseDetails) => {
  if (!caseDetails) return [];
  const studyPurpose = caseDetails?.studyPurpose;
  const studyPurposeValue = STUDY_PURPOSES.filter(
    (purpose) =>
      isBoolean(studyPurpose[purpose?.fieldName]) &&
      studyPurpose[purpose?.fieldName]
  ).map((purpose) => {
    return purpose.label;
  });

  return [
    {
      label: 'Selected Purposes',
      value: (
        <Row gutter={[16, 16]}>
          {studyPurposeValue?.map((purpose) => (
            <Col key={purpose}>
              <Tag>{purpose}</Tag>
            </Col>
          ))}
        </Row>
      ),
    },
    {
      label: APP_TERMS.region_interest_cases_comments_label,
      value: (
        <div
          dangerouslySetInnerHTML={{ __html: studyPurpose?.doctorsNotes }}
        ></div>
      ),
    },
  ];
};
export const getCaseStatusColor = (caseStatus) => {
  let color;
  switch (caseStatus) {
    case CASE_STATUS_CREATED:
      color = '#6f42c1';
      break;
    case CASE_STATUS_DRAFTED:
      color = '#0dcaf0';
      break;
    case CASE_STATUS_SUBMITTED:
      color = '#198754';
      break;
    case CASE_STATUS_COMPLETED:
      color = '#20c997';
      break;
    case CASE_STATUS_ARCHIVED:
      color = '#6c757d';
      break;

    default:
      break;
  }
  return color;
};
